<span class="welcome-text">Bonjour {{ userConnected.displayName }}</span>

<a class="banner-icon" routerLink="/profile" (mouseover)="displayProfile = true" (mouseout)="displayProfile = false">
    <fa-icon [icon]="userProfileIcon"></fa-icon>
</a>

@if (displayProfile) {
    <div class="tooltip-profile">
        <p>
            <span class="label">Organisation :</span>
            {{ userConnected.organization.name }}
        </p>
        <p>
            <span class="label">Compte :</span>
            {{ userConnected.login }} ({{ userConnected.userId }})
        </p>
        <p>
            <span class="label">Groupes :</span>
            {{ userConnected.groupName }}
        </p>
        <p>
            <span class="label">Rôles :</span>
            {{ userConnected.roleName }}
        </p>
    </div>
}
